import React from 'react';
import Client from './components/Client';
import { useSearchParams } from 'react-router-dom';
import { useDataStore } from './dataStore';
import { findLanguage, getLanguageIref, resolveSelectedLanguage } from './i18n';
import {
  fetchMobileText,
  getMobileTextValue,
  MobileHtmlContent,
  MobileStandalonePage,
  MobileSurface,
} from './components/MobileStandalone';

// Functional wrapper for Privacy component
function PrivacyWrapper() {
  const [searchParams] = useSearchParams();
  const { languages, selectedLanguage, defaultLanguage, languageReady } = useDataStore();
  const queryLanguage = searchParams.get('language') || searchParams.get('lang') || '';
  const shouldWaitForQueryLanguage = Boolean(queryLanguage) && !languageReady;
  const resolvedQueryLanguage = queryLanguage ? findLanguage(languages, queryLanguage) : null;
  const language = resolvedQueryLanguage || resolveSelectedLanguage(languages, selectedLanguage?.iref, defaultLanguage);

  if (shouldWaitForQueryLanguage) {
    return (
      <MobileStandalonePage center maxWidth={680}>
        <MobileSurface sx={{ minHeight: 180 }} />
      </MobileStandalonePage>
    );
  }

  return <Privacy language={language} defaultLanguage={defaultLanguage} />;
}
class Privacy extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      terms: {},
    };

    this.getData = this.getData.bind(this);
  }

  
  componentDidMount() {
    this.getData ( );
  }

  componentDidUpdate(prevProps) {
    if (
      getLanguageIref(prevProps.language) !== getLanguageIref(this.props.language) ||
      getLanguageIref(prevProps.defaultLanguage) !== getLanguageIref(this.props.defaultLanguage)
    ) {
      this.getData();
    }
  }

  componentWillUnmount() {
  }

  getData ( ) {
    const languageIref = getLanguageIref(this.props.language);
    const privacy = fetchMobileText(this.state.client, "PRIVACY", languageIref);

    this.setState({
      terms: privacy || {},
    });
  }
  
  render() {
    const html = getMobileTextValue(
      this.state.terms,
      "",
      this.props.language,
      this.props.defaultLanguage
    );

    return (
      <MobileStandalonePage maxWidth={680}>
        <MobileSurface sx={{ p: { xs: 2, sm: 3 } }}>
          <MobileHtmlContent html={html} />
        </MobileSurface>
      </MobileStandalonePage>
    );
  }
}

export default PrivacyWrapper;
